import { Frequency } from 'models/frequency';
import { IShoppingCart } from 'models/shoppingCart';
import { IShoppingCartItem } from 'models/shoppingCartItem';

import { Action } from './appState';

export interface CartState {
  userCart?: IShoppingCart;
  buyingMonthly: boolean;
  error?: string;
}

export const CartTypes = {
  LOAD_SUCCESS: 'LOAD_SUCCESS',
} as const;

export type CartType = (typeof CartTypes)[keyof typeof CartTypes];

export const initialState: CartState = {
  userCart: undefined,
  buyingMonthly: false,
  error: undefined,
};

export const isBuyingMonthly = (userCart?: IShoppingCart): boolean => {
  return (
    userCart?.shopping_cart_items?.some(
      (cartItem: IShoppingCartItem) =>
        cartItem.frequency.code === Frequency.Monthly,
    ) ?? false
  );
};

const reducer = (state: CartState, action: Action<CartType>): CartState => {
  switch (action.type) {
    case CartTypes.LOAD_SUCCESS: {
      const userCart = action.payload;
      return {
        ...state,
        userCart,
        buyingMonthly: isBuyingMonthly(userCart),
        error: undefined,
      };
    }

    default:
      // In production, return current state for unknown actions
      // This prevents the app from crashing
      if (process.env.NODE_ENV === 'development') {
        console.warn(`Unknown action type: ${action.type}`);
      }
      return state;
  }
};

export default reducer;
